<template>
    <div class="modal fade" id="ownerList" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="card-header px-2">
                    <h3 class="card-title">{{ $t('label.select_owner') }}</h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-dismiss="modal" aria-label="Close" :title="$t('label.close')">
                            <fa :icon="fas.faTimes" style="color: red;"/>
                        </button>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group mb-2">
                                <input @keyup.enter="getOwners(1)" type="text" class="form-control" v-model="search" :placeholder="$t('label.search')">
                                <div @click="getOwners(1)" class="input-group-append cursor-pointer">
                                    <span class="input-group-text">
                                        <fa :icon="fas.faSearch"/>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <button type="button" class="btn btn-success mr-2" v-on:click="reloadOwner" :title="$t('label.reload')">
                                <fa :icon="fas.faSyncAlt"/>
                            </button>
                            <button type="button" class="btn btn-primary" @click="newOwner" v-if="this.$hasPermission('tempvehicle.owner.create')">
                                <fa :icon="fas.faPlus"/>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive" v-if="owners.length > 0">
                                <table class="table table-bordered mb-0">
                                    <tr>
                                        <th>{{$t('label.first_name')}}</th>
                                        <th>{{$t('label.last_name')}}</th>
                                        <th style="width: 5%;" nowrap>
                                            <span class="d-none d-md-inline-flex">
                                                {{$t('label.select')}}
                                            </span>
                                        </th>
                                    </tr>
                                    <tr v-for="(owner, index) in owners" :key="index">
                                        <td>
                                          <router-link :to="{ name: 'ViewOwner', params: { id : owner.uuid }}" target="_blank">
                                            {{ owner.first_name }}
                                          </router-link>
                                        </td>
                                        <td>
                                          <router-link :to="{ name: 'ViewOwner', params: { id : owner.uuid }}" target="_blank">
                                            {{ owner.last_name }}
                                          </router-link>
                                        </td>
                                        <td class="text-center"><input type="radio" class="checkbox" :value="owner" v-model="selected_owner" /></td>
                                    </tr>
                                </table>
                            </div>
                            <div class="callout callout-success" v-else>
                                <label>{{ $t('label.no_data') }}</label>
                            </div>
                        </div>
                    </div>
                    <template v-if="owners.length > 0">
                      <paginate class="pagination-sm mb-0"
                                :page-count="last_page"
                                :force-page="forcePage"
                                :page-range="3"
                                :margin-pages="2"
                                :click-handler="getOwners"
                                :container-class="'pagination float-right'"
                                :prev-text="'Prev'"
                                :prev-class="'page-item'"
                                :next-text="'Next'"
                                :next-class="'page-item'"
                                :page-class="'page-item'"
                                :active-class="'active'"
                                :prev-link-class="'page-link'"
                                :next-link-class="'page-link'"
                                :page-link-class="'page-link'"
                                ref="vehicle_paginate">
                      </paginate>
                    </template>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        {{ $t('label.close') }}
                    </button>
                    <button :disabled="!selected_owner.first_name" type="button" v-on:click="selectedOwner" class="btn btn-primary">
                        {{ $t('label.ok') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { fas } from "@fortawesome/free-solid-svg-icons";
    export default {
        name: "owner-list",
        data() {
            return {
                baseURI: "",
                owners: [],
                selected_owner: {},
                search: '',
                forcePage: 1,
                last_page: 0,
            }
        },
        computed: {
            fas() {
                return fas;
            },
            ownerModalData(){
              return this.$store.getters['application/ownerData'];
            }
        },
        watch: {
          ownerModalData(value){
            if(value){
              this.getOwners();
              this.selected_owner = value;
              this.selectedOwner();
              this.$forceUpdate();
            }
          }
        },
        mounted() {
          this.getOwners();
        },
        methods: {
            getOwners(pageNumber = 1) {
                this.$store.state.loading.status = true;
                this.forcePage = pageNumber;
                this.forcePage = pageNumber;
                let url = this.baseURI + 'owners?page=' + pageNumber + '&per_page='+5;
                if(this.search){
                  url = url + '&search=' + this.search;
                }
                GDCE_Client.requestApi("GET", url).then(response => {
                  this.owners = response.data.data;
                  this.last_page = response.data.last_page;
                  this.$store.dispatch('application/setOwners', response.data.data);
                  this.$store.state.loading.status = false;
                }).catch(()=>{});
            },
            reloadOwner: function() {
                this.search = '';
                this.getOwners();
            },
            selectedOwner() {
                // this.selected_owner.border_pass_number = '';
                // this.selected_owner.border_pass_date = null;
                this.$emit('selectedOwner', this.selected_owner);
                $('#ownerCreateModal').modal('hide');
                $("#ownerList").modal("hide");
            },
            newOwner() {
                //let routeData = this.$router.resolve({name: 'CreateOwner'});
                //window.open(routeData.href, '_blank');
                $('#ownerCreateModal').modal('show');
            }
        }
    }
</script>

<style scoped>
    /**
    * https://codepen.io/Sambego/pen/zDLxe/
    */
    .checkbox {
        position: relative;
        top: -0.375rem;
        margin: 0 1rem 0 0;
        cursor: pointer;
    }
    .checkbox:before {
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        content: "";
        position: absolute;
        left: 0;
        z-index: 1;
        width: 20px;
        height: 20px;
        border: 2px solid rgba(52, 51, 69, 0.49);
        background: rgba(255, 255, 255, 0);
    }
    .checkbox:checked:before {
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        transform: rotate(-45deg);
        height: .5rem;
        border-color: #009688;
        border-top-style: none;
        border-right-style: none;
    }
    .checkbox:after {
        content: "";
        position: absolute;
        top: -0.125rem;
        left: 0;
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 1);
        cursor: pointer;
    }
    .button--round i {
        font-size: 1rem;
        line-height: 220%;
        vertical-align: middle;
    }
    @-webkit-keyframes slideUp {
        0% {
            -webkit-transform: translateY(6.25rem);
            transform: translateY(6.25rem);
        }
        100% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
    }
    @keyframes slideUp {
        0% {
            -webkit-transform: translateY(6.25rem);
            transform: translateY(6.25rem);
        }
        100% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
    }
    .btn:disabled{
      cursor: default !important;
    }
</style>